import { render, staticRenderFns } from "./ButtonCount.vue?vue&type=template&id=72c22a0a&scoped=true&lang=pug&"
import script from "./ButtonCount.vue?vue&type=script&lang=js&"
export * from "./ButtonCount.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCount.vue?vue&type=style&index=0&id=72c22a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c22a0a",
  null
  
)

export default component.exports